<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>Olá! Queremos conhecer você!</h2>
      <p>
        As informações geradas nesse módulo nos ajudarão a conhecer melhor os
        servidores da Universidade; seus interesses, habilidades e formação.
      </p>
    </div>

    <div>
      <h2>Cadastro</h2>
      <p>
        Na aba <span class="info--text">CADASTRO</span>, você deve informar
        alguns dados pessoais e visualizar seus dados profissionais. Caso alguma
        informação da área de dados profissionais esteja desatualizada, você
        pode procurar a Central de Relacionamento da Pró-Reitoria de Gestão de
        Pessoas.
      </p>
    </div>

    <div>
      <h2>Formação</h2>
      <p>
        Na aba <span class="info--text">FORMAÇÃO</span>, cadastre seus cursos
        acadêmicos e sua formação complementar (idiomas e cursos de
        capacitação). Você pode também indicar até três áreas de pesquisa
        relacionadas à sua formação, registrar se tem interesse em ser instrutor
        de algum curso de capacitação e indicar até cinco cursos.
      </p>
    </div>

    <div>
      <h2>Atuação Profissional</h2>
      <p>
        Na aba <span class="info--text">ATUAÇÃO PROFISSIONAL</span>, você pode
        especificar quais foram as suas experiências profissionais e cadastrar
        até cinco áreas em que atua ou atuou profissionalmente.
      </p>
    </div>

    <div>
      <h2>Atividades de Interesse</h2>
      <p>
        Na aba <span class="info--text">ATIVIDADES DE INTERESSE</span>, cadastre até
        cinco atividades que lhe interessam nas áreas de cultura, arte e
        esporte. Você também pode informar se tem interesse em ser instrutor de
        alguma atividade nessas áreas e indicar até cinco cursos.
      </p>
    </div>

    <div>
      <h2>Preferências de Trabalho</h2>
      <p>
        Na aba <span class="info--text">PREFERÊNCIAS DE TRABALHO</span>, você
        deve escolher entre duas possíveis situações que nos ajudarão a
        complementar o seu perfil.
      </p>
    </div>

    <div>
      <h2>Meu Perfil</h2>
      <p>
        Na aba <span class="info--text">MEU PERFIL</span>, você encontra a
        síntese dos seus dados. Verifique se todas as informações constantes
        nesta aba estão corretas.
      </p>
    </div>

    <div>
      <h2>Importante!</h2>
      <p class="text-start font-weight-medium text-lg-h2">
        Você pode rever esse tutorial e o termo de responsabilidade clicando nos
        botões na cor azul, localizados no lado direito superior em qualquer
        tela do Perfil.
      </p>
      <p class="text-start font-weight-medium text-lg-h2">
        As informações desse módulo devem estar sempre atualizadas, por isso,
        você pode alterá-las sempre que desejar. Essas informações são muito
        importantes para a gestão de pessoas da Universidade.
      </p>
      <v-btn
        text
        x-large
        color="success"
        @click="close()"
      >
        Vamos começar?
      </v-btn>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialPerfil',

  components: { BaseTutorial },

  data() {
    return {
      steps: [
        'Introdução',
        'Cadastro',
        'Formação',
        'Atuação Profissional',
        'Atividades de Interesse',
        'Preferências de Trabalho',
        'Meu Perfil',
        'Importante',
      ],
    };
  },

  inject: ['close'],
};
</script>
